import React, { Component } from "react";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import LoadingIndicatorHeader from "../loading-indicator/loading-indicator-header";
import SpotDetailSpot from "./spot-detail-spot";
import SpotDetailPod from "./spot-detail-pod";
import util from "../util/util";

const jQuery = window.jQuery;

export default class SpotDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: Number(this.props.params.id), // id of the spot displayed
      loaded: false // ready to display
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.getSpot();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getSpot() {
    util.getSpot(this.state.id).then(data => {
      setTimeout(() => {
        this.mounted &&
          this.setState({
            id: data.id,
            description: data.description,
            loaded: true,
            name: data.name,
            sourceFile: data.source_file,
            sourceType: Number(data.source),
            sourceUrl: data.source_url,
            status: data.aws_status,
            statusMessage: data.aws_status_message,
            created: data.created,
            updated: data.updated,
            elementId: data.element_id,
            clientName: data.client_name,
            protrackId: data.protrack_id,
            tape: data.tape,
            duration: data.duration ? (data.duration / 1000).toFixed(2) : "",
            pods: data.pod_relations
              .filter(pr => pr.pod && pr.pod.id)
              .map((e, i) => {
                return e.pod;
              })
          });
      }, util.delayDetail);
    });
  }

  deleteSpot(spot) {
    const title = `Delete Spot`;
    let body = `<p>Are you sure you want to delete the pod: <strong>${spot.name}</strong>?</p>`;
    body += `<p>Existing Pods that use this spot will not affected.</p>`;
    const buttonTextDefault = `Delete Spot`;
    const buttonTextLoading = `Deleting Spot`;
    const iconClass = `fa-trash-o`;
    const $modal = util.renderModal(
      title,
      body,
      buttonTextDefault,
      buttonTextLoading,
      iconClass
    );
    const $confirmButton = $modal.find(`.btn-danger`);

    // attach temporary event to remove the spot on confirmation of the modal;
    // remove any previous events first;
    // dont namespace the event because we want to remove everything;
    $confirmButton.one(`click`, () => {
      $confirmButton.button(`loading`);
      util
        .deleteSpot(spot.id)
        .fail(() => {
          setTimeout(() => {
            // reset the button on fail so it can be clicked again;
            $confirmButton.button(`reset`);
          }, util.delayForm);
        })
        .then(() => {
          // once done, go back to the list of pods
          $modal.modal(`hide`);
          browserHistory.push(`/spots/`);
        });
    });

    // attach the modal to the DOM, and then show it;
    jQuery(`body`).append($modal);
    $modal.modal(`show`);
  }

  render() {
    if (this.state.loaded === false) {
      return <LoadingIndicatorHeader />;
    } else {
      return (
        <div className="spot-detail">
          <SpotDetailSpot
            spot={this.state}
            deleteSpot={spot => this.deleteSpot(spot)}
          />

          <hr className="spacer" />

          <SpotDetailPod
            pods={this.state.pods}
            spotId={this.state.id}
            spotStatus={this.state.status}
          />
        </div>
      );
    }
  }
}

SpotDetail.propTypes = {
  params: PropTypes.object
};
